
export class AppVersion {

  number!: string;
  commit!: string;
  buildTime!: Date;

  static current: AppVersion = { number: '57', commit: 'a431753', buildTime: new Date('2025-11-05T07:15:11.425Z') };
}